<template>
<div class="chapter">
<div class="inner_page">
<p class="parttitle"><a id="page_31"></a><span class="small">PART I</span></p>
<p class="parttitle1">Toward a Rhetorical Genealogy of <i>Othello</i><a id="page_32"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_part01.vue?3d12e0c2